import type { ComputedValue, ComputedOverwrite } from "@/types/types";

function computedValuesToComputedOverwrites(computedValues: ComputedValue[]): ComputedOverwrite[] {
    return computedValues.map(({ value, name, type, layer, publisherPlatform, settings }) => ({
        newValue: value,
        name,
        type,
        layer,
        isPublisherPlatform: !!publisherPlatform,
        settings,
        htmlTag: "manifest"
    }));
}

export default computedValuesToComputedOverwrites;
